/* NOVITAS ÉDITORIAL — révélations au scroll */
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll('main .shopify-section');
  targets.forEach(function(el, i){
    if (el.querySelector('.novitas-hero')) return; // le hero a sa propre animation
    el.classList.add('nov-reveal');
  });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('nov-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.nov-reveal').forEach(function(el){ io.observe(el); });
})();
